<template>
  <div class="answer">
    <div
      v-for="(item, index) in answerData"
      :key="index"
      class="contetn"
      @click="handleItem(item)"
    >
      <img class="results" src="./../../assets/treat/kuang.png" alt />
      <div class="text">
        <div>{{ item.petType === 'dog' ? '犬类' : '猫类' }}</div>
        <div>{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSlideOtherPaperAndAnswer } from '@/api/system/exam'
export default {
  data() {
    return {
      answerData: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    //获取题及答案
    init() {
      getSlideOtherPaperAndAnswer().then((res) => {
        if (res.data.code === 0) {
          this.answerData = res.data.data
        }
      })
    },
    handleItem(item) {
      this.$router.push({
        path: '/treat/pdf',
        query: { url: item.answer }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.answer {
  width: 100%;
  min-height: 100vh;
  background-image: url('./../../assets/home/cbbj.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  align-content: flex-start;
  box-sizing: border-box;
  justify-content: space-between;
  padding: 204px 48px 0px 48px;
  .contetn {
    width: 300px;
    height: 303px;
    font-size: 40px;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 102px;
    position: relative;
    .text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      div {
        width: 200px;
        text-align: center;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>